if (!window.Eurus.loadedScript.has('preview-color-swatches.js')) {
  window.Eurus.loadedScript.add('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
        featuredImage = null // Optional 4th parameter for compatibility
      ) => ({
        currentVariantCard: '',
        currentImage: '',
        options: [],
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {          
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.checkVariantSelected();
            this.currentVariantCard = e.detail.currentVariant;
            this.options = e.detail.options;
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }));

      Alpine.data('xDoubleTouch', (productUrl) => ({
        lastTapTime: 0,
        DOUBLE_TAP_DELAY: 300,
        singleTapTimeout: null,
        touchStartX: 0,
        touchStartY: 0,
        touchMoved: false,
        MAX_MOVE_THRESHOLD: 10,
        showSecond: false,

        onTouchStart(event) {
          const touch = event.touches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchMoved = false;
        },
  
        onTouchMove(event) {
          const touch = event.touches[0];
          const deltaX = Math.abs(touch.clientX - this.touchStartX);
          const deltaY = Math.abs(touch.clientY - this.touchStartY);
          if (deltaX > this.MAX_MOVE_THRESHOLD || deltaY > this.MAX_MOVE_THRESHOLD) {
            this.touchMoved = true;
          }
        },
  
        onTouchEnd(splide, carousel) {
          if (this.touchMoved) {
            return;
          }
  
          const currentTime = new Date().getTime();
          const tapLength = currentTime - this.lastTapTime;
  
          if (tapLength < this.DOUBLE_TAP_DELAY && tapLength > 0) {
            clearTimeout(this.singleTapTimeout);
            this.lastTapTime = 0;
            this.onDoubleTap(splide, carousel);
          } else {
            this.lastTapTime = currentTime;
            this.singleTapTimeout = setTimeout(() => {
              this.onSingleTap();
            }, this.DOUBLE_TAP_DELAY);
          }
        },
  
        onSingleTap() {
          window.location.href= productUrl
        },
  
        onDoubleTap(splide, carousel) {
          if (carousel) {
            Alpine.store('xSplide').togglePlayPause(splide)
          } else {
            this.showSecond = !this.showSecond;
          }
        }
      }));

Alpine.store('xPreviewColorSwatch', {
  generateColorVariations(colorName) {
    // Generate multiple variations of the color name for matching
    const variations = [];
    
    // Basic transformations
    const basic = colorName.toLowerCase();
    const noSpaces = basic.replace(/\s+/g, '');
    const hyphenated = basic.replace(/\s+/g, '-');
    const underscored = basic.replace(/\s+/g, '_');
    
    // Handle apostrophes
    const apostropheVariations = [
      basic.replace(/'/g, 's'),
      basic.replace(/'/g, ''),
      basic.replace(/'/g, '-')
    ];
    
    // Handle special cases
    variations.push(basic, noSpaces, hyphenated, underscored);
    variations.push(...apostropheVariations.map(v => v.replace(/\s+/g, '-')));
    variations.push(...apostropheVariations.map(v => v.replace(/\s+/g, '')));
    
    // Multi-word handling
    const words = colorName.toLowerCase().split(/\s+/);
    if (words.length > 1) {
      // Just first word
      variations.push(words[0]);
      
      // Just last word
      variations.push(words[words.length - 1]);
      
      // Abbreviated (first letter of each word)
      variations.push(words.map(w => w[0]).join(''));
      
      // Common abbreviations
      if (colorName.includes('Blue')) {
        variations.push(basic.replace(/blue/gi, 'blu'));
      }
      if (colorName.includes('Christmas')) {
        variations.push(basic.replace(/christmas/gi, 'xmas'));
        variations.push(basic.replace(/christmas/gi, 'holiday'));
      }
    }
    
    // Special character removal
    variations.push(basic.replace(/[^a-z0-9]/g, ''));
    variations.push(basic.replace(/[^a-z0-9]/g, '-'));
    
    // Remove duplicates and empty strings
    return [...new Set(variations)].filter(Boolean);
  },
  
  async onChangeVariant(el, productUrl, src, variantId, sectionId, isColor = false) {
        //  console.log("-------- productUrl : ", productUrl);
        //  console.log("-------- variantId : ", variantId);
        //  console.log("-------- variant-handle : ", el.getAttribute("variant-handle"));

         let variantHandle = el.getAttribute("variant-handle");
         
          console.log("el", el);
          setTimeout(async () => {
            document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
              if (e.detail.currentVariant == null) {
                this.updateImage(el, productUrl, src, variantId, sectionId);
              }
            });

        // Update image immediately for color swatches
        if (isColor) {
          console.log('Color swatch clicked:', el.value, 'Variant ID:', variantId);
              
              // Debug: Let's see what's in the DOM structure
              const cardProduct = el.closest('.card-product');
              
              // Try multiple ways to find the variant data
              let variantContainer = el.closest('.x-variants-data');
              if (!variantContainer && cardProduct) {
                variantContainer = cardProduct.querySelector('.x-variants-data');
              }
              
              let variantImage = null;
              
        // Try to find variant image in multiple ways
        
        // METHOD 1: Look for hidden variant images container
        const variantImagesContainer = cardProduct ? cardProduct.querySelector('.variant-images-container') : null;
        if (variantImagesContainer) {
          console.log('METHOD 1: Checking variant images container for:', el.value);
          
          // Debug: Let's see what's inside the container
          const allImages = variantImagesContainer.querySelectorAll('img');
          
          // Try to find by color name (option1)
          const colorName = el.value;
          const variantImageByColor = variantImagesContainer.querySelector(`img[data-variant-image="${colorName}"]`);
          if (variantImageByColor) {
            variantImage = variantImageByColor.src;
          }
          
          // Also try by variant ID
          if (!variantImage) {
            const variantImageById = variantImagesContainer.querySelector(`img[data-variant-id="${variantId}"]`);
            if (variantImageById) {
              variantImage = variantImageById.src;
              console.log('METHOD 1: Found variant image by ID:', variantImage);
            }
          }
        }
        
        // METHOD 2: Check script tags with variant data
        if (!variantImage) {
          console.log('METHOD 2: Checking script tags for variant data');
          const scriptTags = cardProduct ? cardProduct.querySelectorAll('script[type="application/json"]') : [];
          
          scriptTags.forEach((scriptTag, index) => {
            try {
              const data = JSON.parse(scriptTag.textContent);
              
              // Check if this is an array of variants
              if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('id')) {
                
                // Find the variant that matches the variantId
                const matchingVariant = data.find(v => v.id === parseInt(variantId));
                if (matchingVariant) {
                  
                  // Handle different possible image property names
                  if (matchingVariant.featured_image) {
                    variantImage = matchingVariant.featured_image.src || matchingVariant.featured_image;
                    console.log('METHOD 2: Found variant featured_image:', variantImage);
                  } else if (matchingVariant.image) {
                    variantImage = matchingVariant.image.src || matchingVariant.image;
                    console.log('METHOD 2: Found variant image:', variantImage);
                  } else if (matchingVariant.image_id || matchingVariant.featured_media) {
                    console.log('METHOD 2: Variant has image_id or featured_media but no direct image URL');
                  }
                }
              }
            } catch (e) {
              // Not JSON or not relevant
            }
          });
        }

          // METHOD 3: For Combined Listings - try to find the child product
          if (!variantImage && el.value) {
            console.log('Checking if this is a combined listing for color:', el.value);
          
          // Extract base product handle and construct new handle
          const urlParts = productUrl.split('/');
          const currentHandle = urlParts[urlParts.length - 1];
          
          // Common patterns for combined listing handles
          const baseHandle = currentHandle.replace(/-halloween$/, '');
          const colorSlug = el.value.toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/'/g, 's')  // Replace apostrophes with 's' 
            .replace(/[^\w-]/g, ''); // Remove other special characters
          
            // Generate multiple possible handles
            const handleVariations = [];
            
            // Standard pattern: base-handle-color-slug
            handleVariations.push(`${baseHandle}-${colorSlug}`);
            
            // For "Blue and White Stripes" -> try "stripes" pattern
            if (el.value === 'Blue and White Stripes') {
              handleVariations.push('charles-pocket-t-shirt-and-short-set-stripes');
              handleVariations.push(`${baseHandle.replace('boys-pima-cotton-short-set', 'pocket-t-shirt-and-short-set')}-stripes`);
            }

            // For "African Elephant Blue" -> the handle uses "elephants" plural
            if (el.value === 'African Elephant Blue') {
              handleVariations.push('jack-boys-pima-cotton-pajama-pant-set-african-elephants');
            }
            
            // Try just the color slug
            handleVariations.push(colorSlug);
            
            console.log('Trying combined listing handles:', handleVariations);
          
          let foundCombinedListing = false;
          
          // Try each handle variation
          for (const handle of handleVariations) {

            console.log("----- currentHandle : ", currentHandle);
            console.log("-----  handle : ", handle);
            console.log("-----  productUrl : ", productUrl);

            const testUrl = productUrl.replace(currentHandle, variantHandle);
            console.log('Trying handle:', variantHandle);
            
            try {
              const response = await fetch(`${testUrl}.js`);
            if (response.ok) {
              const productData = await response.json();
              console.log('Found combined listing product:', productData.title);

              console.log("------ productData.images : ", productData.images);

              let skeletonImage = null;
              console.log("---------- productData.images[1] : ", productData.images[1]);
              if (productData && productData.images && productData.images[1]) {
                skeletonImage = productData.images[1];
              }
              console.log("-------- skeletonImage : ", skeletonImage);
              
              // Use the featured image from the color-specific product
              if (productData.featured_image) {
                let imageUrl = productData.featured_image;
                if (imageUrl.startsWith('//')) {
                  imageUrl = 'https:' + imageUrl;
                }
                if (!imageUrl.includes('width=')) {
                  imageUrl += (imageUrl.includes('?') ? '&' : '?') + 'width=800';
                }

                if (skeletonImage) {
                  if (skeletonImage.startsWith('//')) {
                    skeletonImage = 'https:' + skeletonImage;
                  }
                  if (!skeletonImage.includes('width=')) {
                    skeletonImage += (skeletonImage.includes('?') ? '&' : '?') + 'width=800';
                  }
                }
                
                console.log('Using featured image from combined listing:', imageUrl);
                foundCombinedListing = true;
                variantImage = imageUrl;
                console.log("---------------- 222222222 skeletonImage : ", skeletonImage)
                this.updateImage(el, productUrl, imageUrl, variantId, sectionId, null, skeletonImage);
                return; // Exit early
              }
            }
          } catch (error) {
            console.log('Error checking handle:', handle, error);
          }
        }
        
        if (!foundCombinedListing) {
          console.log('No combined listing found after trying all handles, moving to METHOD 4');
          }
        }
        
        // METHOD 4: Try direct image URL patterns for known naming conventions
        if (!variantImage && el.value) {
          console.log('METHOD 4: Trying direct image patterns for:', el.value);
          
          // Extract product information from handle
          const productHandle = productUrl.split('/').pop();
          const handleParts = productHandle.split('-');
          
          // Generate various color slugs from the color name
          const colorName = el.value;
          const colorVariations = this.generateColorVariations(colorName);
          
          // Extract product info dynamically
          let productName = '';
          let productType = '';
          
          // Try to identify product name (e.g., "charles", "james", etc.)
          // Look for common product names first
          const knownNames = ['charles', 'james', 'henry', 'william', 'emma', 'olivia', 'sarah'];
          for (const part of handleParts) {
            if (knownNames.includes(part.toLowerCase())) {
              productName = part;
              break;
            }
          }
          
          // Find product type
          const typeIndex = handleParts.findIndex(part => 
            part === 'short' || part === 'long' || part === 'romper' || part === 'dress'
          );
          if (typeIndex !== -1) {
            productType = handleParts[typeIndex];
          }
          
          // If no product name found, try to extract from handle pattern
          if (!productName) {
            // Usually pattern is: brand-material-type-name-color
            // Find pima/cotton position
            const materialIndex = handleParts.findIndex(part => 
              part === 'pima' || part === 'cotton' || part === 'modal'
            );
            
            if (materialIndex !== -1 && typeIndex !== -1 && typeIndex > materialIndex) {
              // Product name is usually right after the type
              if (typeIndex + 1 < handleParts.length - 1) {
                productName = handleParts[typeIndex + 1];
              }
            } else if (handleParts.length > 2) {
              // Last resort - use the last part before any color indicator
              productName = handleParts[handleParts.length - 1];
            }
          }
          
          // Generate image patterns dynamically
          const imagePatterns = [];
          
          // Try various combinations of patterns
          for (const colorSlug of colorVariations) {
            // Pattern 1: Lila-and-Hayes-pima-[boys/boy]-[type]-[name]-[color]
            if (productType && productName) {
              imagePatterns.push(
                `Lila-and-Hayes-pima-boys-${productType}-set-${productName}-${colorSlug}`,
                `Lila-and-Hayes-pima-boy-${productType}-set-${productName}-${colorSlug}`,
                `Lila-and-Hayes-pima-boys-${productType}-${productName}-${colorSlug}`,
                `Lila-and-Hayes-pima-boy-${productType}-${productName}-${colorSlug}`
              );
            }
            
            // Pattern 2: [name]-[color]-pima-cotton-[type]-set
            imagePatterns.push(
              `${productName}-${colorSlug}-pima-cotton-${productType}-set`,
              `${productName}-${colorSlug}-${productType}-set`
            );
            
            // Pattern 3: Simple patterns
            imagePatterns.push(
              `${productName}-${colorSlug}`,
              `${productHandle.replace(/-halloween$/, '')}-${colorSlug}`
            );
            
            // Pattern 4: With brand prefix variations
            imagePatterns.push(
              `lila-hayes-${productName}-${colorSlug}`,
              `lilahayes-${productName}-${colorSlug}`
            );
            
            // Pattern 5: Special patterns for specific colors
            if (colorName === 'Birthday Cake Blue') {
              imagePatterns.push(
                `Lila-and-Hayes-pima-boys-short-set-charles-birthdaycake`,
                `Lila-and-Hayes-pima-boys-short-set-charles-birthday-cake-blue`,
                `charles-birthday-cake-blue-pima-cotton-short-set`,
                `charles-birthdaycake-short-set`
              );
            }
            
            if (colorName === 'Under the Christmas Tree') {
              imagePatterns.push(
                `LilaandHayesBabyPimaCottonPajamasParkerUndertheChristmasTree`,
                `Parker-Under-the-Christmas-Tree-Pima-Cotton-Zipper-Pajama`,
                `parker-under-the-christmas-tree`,
                `parker-christmas-tree`
              );
            }
            
            if (colorName === 'Candy Cane Lane' && productName.toLowerCase() === 'alden') {
              imagePatterns.push(
                `LilaandHayesDollPimaCottonPajamasAldenCandyCaneLane`,
                `Alden-Doll-Candy-Cane-Lane`,
                `alden-doll-candycanelane`,
                `alden-candy-cane-lane`
              );
            }
            
            if (colorName === 'Holly Holiday') {
              imagePatterns.push(
                `LilaandHayesDollPimaCottonPajamasAldenHollyHoliday`,
                `Alden-Doll-Holly-Holiday`,
                `alden-doll-hollyholiday`,
                `alden-holly-holiday`
              );
            }
            
            if (colorName === 'Nutcracker Ballet') {
              imagePatterns.push(
                `LilaandHayesDollPimaCottonPajamasAldenNutcrackerBallet`,
                `Alden-Doll-Nutcracker-Ballet`,
                `alden-doll-nutcracker-ballet`,
                `alden-nutcracker-ballet`
              );
            }
            if (colorName === 'Blue and White Stripes') {
              imagePatterns.push(
                `${productType}-${productName}-blue-and-white-stripes`,
                `charles-blue-and-white-stripes`,
                `charles-boys-short-set-blue-and-white-stripes`,
                `charles-short-set-blue-white-stripes`,
                `LilaandHayesBoysPimaCottonShortSetCharlesBlueAndWhiteStripes`,
                `LilaandHayesBoysPimaCottonShortSetCharlesBlueWhiteStripes`,
                `Charles_Set_Blue_and_White_Stripes_1`,
                `Charles-Set-Blue-and-White-Stripes`,
                `charles-set-blue-and-white-stripes`,
                `Charles_Blue_White_Stripes`,
                `charles-blue-white-stripes`,
                // Simple patterns
                `blue-and-white-stripes`,
                `blue_and_white_stripes`,
                `blueandwhitestripes`,
                `blue-white-stripes`,
                `bluewhitestripes`,
                `blue_white_stripes`,
                `Blue_and_White_Stripes`,
                `BlueAndWhiteStripes`,
                `Blue-And-White-Stripes`,
                // With numbers
                `blue-and-white-stripes_1`,
                `blue_and_white_stripes_1`,
                `blue-and-white-stripes-1`,
                // Common Shopify patterns
                `il_fullxfull.blue-and-white-stripes`,
                `il_570xN.blue-and-white-stripes`,
            // Try with temp suffix
            `Charles_Set_Blue_and_White_Stripes_1_temp`,
            `charles-set-blue-and-white-stripes-temp`
          );
        }
        if (colorName === 'African Elephant Blue') {
          imagePatterns.push(
            `Jack_African_Elephant_Blue_1`,
            `jack-african-elephant-blue`,
            `Jack_African_Elephant_Blue`,
            `jack_african_elephant_blue_1`,
            `LilaandHayesBoysPimaCottonPajamasJackAfricanElephantBlue`,
            `jack-pima-cotton-pajamas-african-elephant-blue`
          );
        }
          }
          
          // Remove duplicates and empty patterns
          const uniquePatterns = [...new Set(imagePatterns)].filter(Boolean);
          console.log('METHOD 4: Testing', uniquePatterns.length, 'unique patterns for', colorName);
          
          // Track if we've found an image to avoid multiple updates
          let imageFound = false;
          
          // Create promises for all image tests
          const imagePromises = [];
          
          // Try each pattern
          for (const pattern of uniquePatterns) {
            // Try different CDN paths and file extensions
            const cdnPaths = [
              'https://cdn.shopify.com/s/files/1/0878/9728/files/',
              'https://cdn.shopify.com/s/files/1/0878/9728/products/'
            ];
            
            const extensions = ['.jpg', '.png', '.webp'];
            
            for (const cdnPath of cdnPaths) {
              for (const ext of extensions) {
                const testUrl = `${cdnPath}${pattern}${ext}?v=1762897936&width=800`;
                // console.log('METHOD 4: Testing URL:', testUrl); // Too verbose
                
                // Create a promise for each image test
                const imagePromise = new Promise((resolve) => {
                  const img = new Image();
                  img.onload = () => {
                    if (!imageFound) {
                      imageFound = true;
                      this.updateImage(el, productUrl, testUrl, variantId, sectionId);
                      console.log('METHOD 4: Found image at:', testUrl);
                    }
                    resolve(true);
                  };
                  img.onerror = () => {
                    resolve(false);
                  };
                  img.src = testUrl;
                });
                
                imagePromises.push(imagePromise);
              }
            }
          }
          
          // Wait for all image tests to complete
          await Promise.all(imagePromises);
          
          if (imageFound) {
            return; // Exit early if METHOD 4 found an image
          }
          
          // METHOD 4B: Try direct product JSON endpoint for the color
          // This is useful if the color variant is actually its own product
          console.log('METHOD 4B: Trying direct product JSON for color:', el.value);
          
          // Extract base product info
          const urlParts = productUrl.split('/');
          const currentHandle = urlParts[urlParts.length - 1];
          const baseHandle = currentHandle.replace(/-halloween$/, '');
          
          // Generate color slug variations for METHOD 4B
          const colorNameForProduct = el.value;
          const colorProductVariations = [];
          
          // Special case for Birthday Cake Blue -> birthday-cake
          if (colorNameForProduct === 'Birthday Cake Blue') {
            colorProductVariations.push('birthday-cake');
          }
          
          // Generic color slug
          const colorSlug = colorNameForProduct.toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/'/g, 's')
            .replace(/[^\w-]/g, '');
          colorProductVariations.push(colorSlug);
          
          // Try without "blue" suffix for colors that end in Blue
          if (colorNameForProduct.endsWith(' Blue')) {
            const withoutBlue = colorNameForProduct.slice(0, -5).toLowerCase()
              .replace(/\s+/g, '-')
              .replace(/'/g, 's')
              .replace(/[^\w-]/g, '');
            colorProductVariations.push(withoutBlue);
          }
          
          // Special case for Blue and White Stripes - try as a standalone product
          if (colorNameForProduct === 'Blue and White Stripes') {
            colorProductVariations.push('blue-and-white-stripes');
            colorProductVariations.push('stripes'); // The actual handle uses just 'stripes'
          }
          
          // Try different handle patterns
          for (const colorVar of colorProductVariations) {
            let testHandles = [];
            
            // Standard pattern
            testHandles.push(`${baseHandle}-${colorVar}`);
            
            // For "stripes" - try the alternate product handle pattern
            if (colorVar === 'stripes') {
              testHandles.push('charles-pocket-t-shirt-and-short-set-stripes');
              testHandles.push(`${baseHandle.replace('boys-pima-cotton-short-set', 'pocket-t-shirt-and-short-set')}-stripes`);
            }
            
            // Also try just the color slug
            testHandles.push(colorVar);
            
            for (const colorProductHandle of testHandles) {
              console.log('METHOD 4B: Trying handle:', colorProductHandle);
            
            try {
              const response = await fetch(`/products/${colorProductHandle}.json`);
              if (response.ok) {
                const productData = await response.json();
                console.log('METHOD 4B: Found color product:', productData.product.title);
                if (productData.product && productData.product.image) {
                  let imageUrl = productData.product.image.src || productData.product.image;
                  if (imageUrl.startsWith('//')) {
                    imageUrl = 'https:' + imageUrl;
                  }
                  console.log('METHOD 4B: Using featured image:', imageUrl);
                  this.updateImage(el, productUrl, imageUrl, variantId, sectionId);
                  return;
                } else if (productData.product && productData.product.featured_image) {
                  let imageUrl = productData.product.featured_image;
                  if (imageUrl.startsWith('//')) {
                    imageUrl = 'https:' + imageUrl;
                  }
                  console.log('METHOD 4B: Using featured image:', imageUrl);
                  this.updateImage(el, productUrl, imageUrl, variantId, sectionId);
                  return;
                }
              }
            } catch (error) {
              console.log('METHOD 4B: Handle not found:', colorProductHandle);
            }
            } // Close the testHandles loop
          }
        }
        
          // METHOD 5: Use Shopify AJAX API to get variant data
          if (!variantImage && productUrl && variantId) {
            console.log('Using Shopify AJAX API to fetch variant data');
          
          // First try the .js endpoint which returns JSON
          fetch(`${productUrl}.js`)
            .then(response => response.json())
            .then(productData => {
              
              // Find the specific variant
              const variant = productData.variants?.find(v => v.id == variantId);
              if (variant && variant.featured_image) {
                const variantImageUrl = variant.featured_image.src || variant.featured_image;
                
                // Ensure proper URL format
                let finalUrl = variantImageUrl;
                if (finalUrl.startsWith('//')) {
                  finalUrl = 'https:' + finalUrl;
                }
                // Ensure we have a good size
                if (!finalUrl.includes('width=')) {
                  finalUrl += (finalUrl.includes('?') ? '&' : '?') + 'width=800';
                }
                
                // Update the image
                this.updateImage(el, productUrl, finalUrl, variantId, sectionId);
              } else {
                
                // Try to match by color option in media
                const colorName = el.value;
                
                if (productData.media && productData.media.length > 0) {
                  
                  
                  // Try multiple matching strategies
                  let matchingMedia = null;
                  
                  // Strategy 1: Exact match in alt text
                  matchingMedia = productData.media.find(media => 
                    media.alt && media.alt.toLowerCase() === colorName.toLowerCase()
                  );
                  
                  // Strategy 2: Contains match in alt text
                  if (!matchingMedia) {
                    matchingMedia = productData.media.find(media => 
                      media.alt && media.alt.toLowerCase().includes(colorName.toLowerCase())
                    );
                  }
                  
                  // Strategy 3: Match color name without spaces
                  if (!matchingMedia) {
                    const colorNoSpaces = colorName.replace(/\s+/g, '').toLowerCase();
                    matchingMedia = productData.media.find(media => 
                      media.alt && media.alt.replace(/\s+/g, '').toLowerCase().includes(colorNoSpaces)
                    );
                  }
                  
                  // Strategy 4: Use media position based on color option position
                  if (!matchingMedia && variant) {
                    // Get unique color options
                    const colorOptions = [...new Set(productData.variants.map(v => v.option1))];
                    
                    // Find position of current color among color options
                    const colorPosition = colorOptions.indexOf(colorName);
                    
                    if (colorPosition !== -1 && productData.media[colorPosition]) {
                      matchingMedia = productData.media[colorPosition];
                    } else {
                      // Fallback: try to match based on the variant's index
                      const variantIndex = productData.variants.findIndex(v => v.id == variantId);
                      const variantsPerColor = productData.variants.length / colorOptions.length;
                      const mediaIndex = Math.floor(variantIndex / variantsPerColor);
                      
                      if (productData.media[mediaIndex]) {
                        matchingMedia = productData.media[mediaIndex];
                      }
                    }
                  }
                  
                  if (matchingMedia && matchingMedia.src) {
                    let mediaUrl = matchingMedia.src;
                    if (mediaUrl.startsWith('//')) {
                      mediaUrl = 'https:' + mediaUrl;
                    }
                    if (!mediaUrl.includes('width=')) {
                      mediaUrl += (mediaUrl.includes('?') ? '&' : '?') + 'width=800';
                    }
                    this.updateImage(el, productUrl, mediaUrl, variantId, sectionId);
                  } else {
                  }
                } else {
                }
              }
            })
            .catch(error => {
              // Silently handle error
              
              // Fallback: Try sections API
              fetch(`${productUrl}?variant=${variantId}&sections=${sectionId}`, {
                headers: {
                  'Accept': 'application/json',
                }
              })
              .then(response => response.json())
              .then(data => {
                // Process sections response if needed
              })
              .catch(err => {/* Silently handle error */});
            });
        }
        
        // Final fallback: use passed src or data attribute
        const finalSwatch = el.closest('fieldset').querySelector(`input[value="${el.value}"]:checked`)?.labels?.[0];
        const fallbackDataImageUrl = finalSwatch?.dataset?.imageUrl;
              
              // Use variant image if found, otherwise use data attribute, otherwise use src
              const finalImageUrl = variantImage || fallbackDataImageUrl || src;
              
              if (finalImageUrl) {
                this.updateImage(el, productUrl, finalImageUrl, variantId, sectionId);
              }
            }

            if (!isColor) {
              let productVariants = ''

              document.dispatchEvent(new CustomEvent(`eurus:product-variant-get:${sectionId}`, {
                detail: {
                  callback: (variants) => {
                    productVariants = variants;
                  }
                }
              }));

              if (productVariants) {
                let variantSrc = productVariants.reduce((acc, variant) => {
                  if (variant.featured_image) {
                    acc[variant.id] = variant.featured_image.src;
                  }
                  return acc;
                }, {});
        
                const swatchesContainer = el.closest('.options-container');
                if (swatchesContainer) {
                  const swatches = swatchesContainer.querySelectorAll('label.color-watches');
                  const inputs = swatchesContainer.querySelectorAll('input:checked');
      
                  let selectedOption = [];
      
                  inputs.forEach(input => { 
                    if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
                      selectedOption.push(input.value);
                    }
                  });
      
                  let imageSrc = productVariants
                    .filter(variant => selectedOption.every(option => variant.options.includes(option)))
                    .map(variant => `url(${variantSrc[variant.id] ? variantSrc[variant.id] : src})`);
                  
                  swatches.forEach((swatch, index) => {
                    swatch.style.setProperty('--bg-image',  imageSrc[index]);
                  });
                }
              }
            } 
          }, 0) // INP
        },

        updateImage(el, productUrl, src, variantId, sectionId, hasVariant, skeletonImage = null) {

          console.log("------- skeletonImage : ", skeletonImage);
          console.log('updateImage called with:', { src, variantId });
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;
          if (!cardProduct) {
            return;
          }

          console.log("cardProduct : ", cardProduct);
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }
          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant && !hasVariant) {
            currentVariant.innerText = variantId;
          }

          if (src != '') {
            let media = cardProduct.querySelector(`[media="${src}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) {
              return;
            }

            console.log("previewImg : ", previewImg);
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", src);

            
            if (skeletonImage) {
              console.log("------------------- cardProduct : ", cardProduct);
              const designSkeletonImage = cardProduct.getElementsByClassName("design-skeleton-image")[0];
              console.log("designSkeletonImage : ", designSkeletonImage);
              designSkeletonImage.removeAttribute("srcset");
              designSkeletonImage.setAttribute("src", skeletonImage);
            }
            
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },
        updateQuickAdd(productUrl, variantId, quickAddPageParam, productId, el){
          return;
          let url = `${productUrl}?variant=${variantId}&section_id=choose-option&page=${quickAddPageParam}`
          fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const listCurrent = document.querySelectorAll(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            const destination = html.querySelector(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            if (listCurrent.length > 0 && destination) {
              listCurrent.forEach((item)=>{
                const currentPrice = item.closest('.card-product').querySelector(".main-product-price");
                const updatePrice = html.querySelector(".main-product-price");
                if(currentPrice && updatePrice){
                  currentPrice.innerHTML = updatePrice.innerHTML
                }
              })
            } else {
              if (listCurrent.length > 0) {
                listCurrent.forEach((item) => {
                  item.innerHTML = html.querySelector('.form').innerHTML;
                })
              }
              const currentPrice = el?.closest('.card-product')?.querySelector(".main-product-price");
              const updatePrice = html.querySelector(".main-product-price");
              if(currentPrice && updatePrice){
                currentPrice.innerHTML = updatePrice.innerHTML
              }
            }
          })
        }
      });
    })
  });
}    